//#region IMPORTS
import { useTranslation } from "react-i18next";
import { Cog8ToothIcon } from "@heroicons/react/24/outline";
import { NavLink } from "react-router-dom";
import { Menu } from "@headlessui/react";
import classNames from "../../helpers/classNames";
//#endregion

//#region INTERFACE
interface Props {
  disabled?: boolean;
}
//#endregion

export default function InstoreOrdersSettingsDropdown({
  disabled = false,
}: Props) {
  //#region SETUP
  // Translation
  const { t } = useTranslation();
  //#endregion

  //#region RENDER
  return (
    <Menu as="div" className="relative inline-block">
      <Menu.Button
        className={classNames(
          "inline-flex items-center gap-x-2 rounded-md px-2 py-1 text-1xl font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 bg-pink-700 hover:bg-pink-500 focus-visible:outline-pink-700",
          disabled && "cursor-not-allowed opacity-50"
        )}
      >
        <Cog8ToothIcon className="h-5 w-5" />

        {t("rituals.settings")}
      </Menu.Button>

      <Menu.Items className="absolute left-0 z-40 mt-2 w-44 origin-top-left rounded-md bg-white shadow-lg outline-1 outline-black/5">
        <div className="py-1">
          <Menu.Item>
            <NavLink
              className="block px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-900 hover:outline-hidden"
              to="/instoretemplates"
            >
              {t("rituals.templates")}
            </NavLink>
          </Menu.Item>
          <Menu.Item>
            <NavLink
              className="block px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-900 hover:outline-hidden"
              to="/instorethemes"
            >
              {t("rituals.themes")}
            </NavLink>
          </Menu.Item>
          <Menu.Item>
            <NavLink
              className="block px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-900 hover:outline-hidden"
              to="/instoretypes"
            >
              {t("rituals.types")}
            </NavLink>
          </Menu.Item>
          <Menu.Item>
            <NavLink
              className="block px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-900 hover:outline-hidden"
              to="/instoreordertypes"
            >
              {t("rituals.orderTypes")}
            </NavLink>
          </Menu.Item>
        </div>
      </Menu.Items>
    </Menu>
  );
  //#endregion
}
